import React, { useEffect, useRef } from 'react';

import { el, setChildren } from 'redom';

const CONFIGURATION_NAMES = ['read', 'node', 'primary', 'write', 'setAttributes', 'replace', 'add', 'insert', 'remove', 'move', 'preset', 'close', 'resize'];

// The panel keeps calling the newest configuration, since the menu rebuilds it on every render.
function delegateConfiguration(propsReference) {

  const configuration = { breakpoint: propsReference.current.breakpoint };

  function call(name) {
    const target = propsReference.current.configuration[name];
    return target.apply(null, Array.prototype.slice.call(arguments, 1));
  }

  for (let index = 0; index < CONFIGURATION_NAMES.length; index++) {
    configuration[CONFIGURATION_NAMES[index]] = call.bind(null, CONFIGURATION_NAMES[index]);
  }

  return configuration;

}

// The panels are downloaded when one is first opened. props.panel names the creator in './';
// props.value is the editor value, and a new one makes the panel check for outside changes such as undo.
function HeaderSettingsReactWrapper(props) {

  const mountReference = useRef(null);
  const panelReference = useRef(null);
  const propsReference = useRef(props);

  propsReference.current = props;

  useEffect(function onValueChange() {

    if (panelReference.current === null) {
      return;
    }

    // The header can be gone for a moment before the menu closes, as when undo removes it.
    try {
      panelReference.current.refresh();
    } catch (exception) {
      return;
    }

  }, [props.value]);

  useEffect(function onLoad() {

    const mountPoint = mountReference.current;
    let unloaded = false;

    async function loadPanel() {

      setChildren(mountPoint, [el('.layout-settings-loading', [el('ht-spinner', { size: 'small' })])]);

      try {
        const panels = await import('./');
        if (unloaded === false) {
          panelReference.current = panels[props.panel](delegateConfiguration(propsReference));
          setChildren(mountPoint, [panelReference.current]);
          propsReference.current.configuration.resize();
        }
      } catch (exception) {
        setChildren(mountPoint, [el('p.layout-field-note', 'These settings could not be loaded. Refresh the page to try again.')]);
      }

    }

    loadPanel();

    return function onUnload() {
      unloaded = true;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="layout-settings-react-wrapper" ref={mountReference}></div>;

}

export default HeaderSettingsReactWrapper;
